import { ApiError } from "./ApiError";
import { getAuthHeaders } from "./api";

const API_BASE_URL =
    import.meta.env.VITE_API_BASE_URL || "https://stg-native-api.cleverpe.com/api";
export interface InitiateDownPaymentRequest {
    orderId: string;
    email: string;
    firstname: string;
    amount: number;
}

export interface InitiateDownPaymentResponse {
    success: boolean;
    paymentLink: string;
}

export const initiateDownPayment = async (
    request: InitiateDownPaymentRequest
): Promise<InitiateDownPaymentResponse> => {

    const token = localStorage.getItem("journey_token");

    if (!token) {
        throw new ApiError(
            "Journey session expired.",
            401
        );
    }

    const response = await fetch(
        `${API_BASE_URL}/downpayment/initiate`,
        {
            method: "POST",

            headers: {
                ...getAuthHeaders(),
                "Content-Type": "application/json",
            },

            body: JSON.stringify(request),
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new ApiError(
            data?.message ||
            data?.data?.message ||
            "Unable to initiate down payment.",
            response.status,
            data
        );
    }

    return data;
};

export interface DownPaymentSessionResponse {
    success: boolean;
    journey: {
        journeyId: string;
        orderId: string;
        customerName: string;
        customerEmail: string;
        dpAmount: number;
        steps?: {
            DOWNPAYMENT?: {
                status?: string;
            };
        };
    };
}

export const getDownPaymentSession = async (
    orderId: string,
    token: string
): Promise<DownPaymentSessionResponse> => {

    const response = await fetch(
        `${API_BASE_URL}/downpayment/session?orderId=${encodeURIComponent(orderId)}&token=${encodeURIComponent(token)}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new ApiError(
            data?.message ||
            data?.data?.message ||
            "Unable to load down payment details.",
            response.status,
            data
        );
    }

    return data;
};

export interface PublicInitiateDownPaymentRequest {
    orderId: string;
    amount: number;
    firstname: string;
    email: string;
}

export interface PublicInitiateDownPaymentResponse {
    success: boolean;
    paymentLink: string;
}

export const initiatePublicDownPayment = async (
    request: PublicInitiateDownPaymentRequest,
    token: string
): Promise<PublicInitiateDownPaymentResponse> => {

    const response = await fetch(
        `${API_BASE_URL}/downpayment/partner/initiate`,
        {
            method: "POST",

            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },

            body: JSON.stringify(request),
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new ApiError(
            data?.message ||
            data?.data?.message ||
            "Unable to initiate down payment.",
            response.status,
            data
        );
    }

    return data;
};

export interface DownPaymentTransactionStatusResponse {
    success: boolean;
    transactionStatus:
    | "SUCCESS"
    | "FAILED"
    | "PROCESSING";
    canRetry: boolean;
    message: string;
}

export const getDownPaymentTransactionStatus = async (
    orderId: string,
    transactionId: string
): Promise<DownPaymentTransactionStatusResponse> => {

    const response = await fetch(
        `${API_BASE_URL}/downpayment/transaction-status?orderId=${encodeURIComponent(
            orderId
        )}&transactionId=${encodeURIComponent(
            transactionId
        )}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new ApiError(
            data?.message ||
            data?.data?.message ||
            "Unable to fetch transaction status.",
            response.status,
            data
        );
    }

    return data;
};